import { Box, Center, Text } from '@chakra-ui/react';
import * as React from 'react';

import { UserIcon } from '@/imports/ui/chakra/feather';

export const NoPeople: React.FC<{ isSearchResult: boolean }> = ({
  isSearchResult,
}) => {
  return (
    <Center h={96}>
      <Box textAlign="center">
        <UserIcon boxSize={5} color="gray.500" mb="2" />
        <Text fontWeight="semibold" color="gray.700">
          {isSearchResult
            ? 'Nothing matched your search'
            : 'There’s no one here yet'}
        </Text>
        <Text color="gray.600">
          {isSearchResult
            ? 'Try searching something else'
            : 'No one has been associated to this company page yet'}
        </Text>
      </Box>
    </Center>
  );
};
